import { apiRequest } from '@/utils/api-request';

interface PostChatResumeWorkflowResponse {
  data?: {
    message: string;
    node_id: string;
    react_flow_generated_id: string;
    session_id: string;
    success: boolean;
    workflow_id: string;
    request_id: string;
  };
  detail?: string;
}

export const postChatResumeWorkflow = async (
  orgId: string,
  reactFlowGeneratedId: string,
  sessionId: string,
  workflowId: string,
  requestId: string,
) => {
  const payload = {
    node_id: reactFlowGeneratedId,
    session_id: sessionId,
    request_id: requestId,
  };

  const response = await apiRequest<PostChatResumeWorkflowResponse>({
    url: `/chat/${orgId}/${workflowId}/${sessionId}/resume-workflow`,
    method: 'POST',
    target: 'workflow',
    body: payload,
  });

  return response as PostChatResumeWorkflowResponse;
};
